import { useRoute, useRouter } from "vue-router";

function router() {
  //跳转路由对象
  const route = useRoute();
  //VueRouter
  const router = useRouter();
  let zRouter = {
    route,
    router,
    push: (url) => {
      router.push(url);
    },
    replace: (url) => {
      router.replace(url);
    },
    back: () => {
      router.go(-1);
    },
    go: (delta) => {
      router.go(delta);
    },
  };
  return zRouter;
}

//const zRouter = {
//  install(Vue) {
//    Vue.provide("$zRouter", router);
//  },
//  zRouter: router,
//};
export default router;

export const $zRouter = router;
